import { createSelector } from '@ngrx/store';
import { AppState } from '../reducers/app.state';

export const selectDeliveredMedicationsState = (state: AppState) => state.deliveredMedicationsData;
export const selectDeliveredMedicationsStateItems = (state: AppState) => state.deliveredMedicationsData.items;
export const selectDeliveredMedicationsStateErrors = (state: AppState) => state.deliveredMedicationsData.errors;
export const selectIsDeliveredMedicationsLoading = (state: AppState) => state.deliveredMedicationsData.loading;
export const selectDeliveredMedicationsShowDisclaimer = (state: AppState) => state.deliveredMedicationsData.showDisclaimer;

export const selectTotalAmountOfItems = (state: AppState) => state.deliveredMedicationsData.totalItems;
export const selectDeliveredMedicationsIsLoaded = (state: AppState) => state.deliveredMedicationsData.isLoaded;

export const selectDeliveredMedicationByDguid = (dguid: string) => createSelector(
  selectDeliveredMedicationsStateItems,
  deliveredMedicationsItems =>
    deliveredMedicationsItems?.length > 0
      ? deliveredMedicationsItems.find(item => item.dguid === dguid)
      : null
);
